export const getInitialState = (): any => ({
  modelSummarySaveData: {},
  modelSummarySaveStatus: 0
});
